/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rights_Cap_Mcp_Use_DescInputs */



/**
* | output |
* | --- |
* | "Allows using connected MCP servers and their tools in chats." |
*
* @param {Rights_Cap_Mcp_Use_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const rights_cap_mcp_use_desc = /** @type {((inputs?: Rights_Cap_Mcp_Use_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rights_Cap_Mcp_Use_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Erlaubt die Nutzung verbundener MCP-Server und ihrer Tools in Chats.")
	return /** @type {LocalizedString} */ ("Allows using connected MCP servers and their tools in chats.")
});